<template>
  <div class="page-box" v-if="show">
    <div class="box" style="padding: 15px; margin: 10px">
      <div class="top" style="font-size: 15px">
        充值卡号：
        <span id="ceshi2">{{ zhenduan.card }}</span>
        <span
          style="margin-left: 15px; color: #3491fa"
          @click="copy(zhenduan.card)"
        >
          复制卡号
        </span>
      </div>
      <div
        style="display: flex; justify-content: space-around; padding-top: 15px"
      >
        <van-button
          @click="url(1)"
          type="primary"
          style="border-radius: 10px"
          size="small"
        >
          立即充值
        </van-button>
        <van-button
          @click="url(2)"
          type="info"
          style="border-radius: 10px"
          size="small"
        >
          联系客服
        </van-button>
        <van-button
          @click="url(3)"
          type="warning"
          style="border-radius: 10px"
          size="small"
        >
          查看教程
        </van-button>
      </div>
    </div>
    <div class="box" style="margin: 10px">
      <div class="top" style="font-size: 16px; padding-top: 15px">
        {{ zhenduan.liveCodeTitle }}
      </div>
      <div
        v-html="zhenduan.liveCodeContent"
        class="titleas1111"
        @click="showImages($event)"
        style="padding-bottom: 5px"
      ></div>
    </div>
    <van-image-preview
      v-model="showImage"
      :images="[images]"
    ></van-image-preview>
  </div>
</template>

<script>
  import { getInfo } from "@/api/cardOperation";

  export default {
    beforeCreate() {
      document
        .querySelector("body")
        .setAttribute("style", "background:#f5f5f5");
    },
    beforeDestroy() {
      document.querySelector("body").setAttribute("style", "");
    },
    data() {
      return {
        show: false,
        //检测卡号
        card: "",
        images: "",
        //检测详情
        zhenduan: {
          card: "暂无卡号",
          customerServiceLink: "",
          id: 27,
          liveCodeContent: "暂未设置",
          liveCodeTitle: "暂未设置",
          rechargeLink: "",
          tutorialLink: "",
        },
        //检测结果
        result: 0,
        showImage: false,
      };
    },
    created() {},
    async mounted() {
      await this.autoTestCard();
    },
    methods: {
      showImages(e) {
        if (e.target.tagName == "IMG") {
          this.images = e.target.src;
          this.showImage = true;
        }
      },
      url(val) {
        if (val == 1) {
          if (this.zhenduan.rechargeLink) {
            if (this.zhenduan.rechargeLink.indexOf("card=") == -1) {
              window.location.href = this.zhenduan.rechargeLink;
            } else {
              window.location.href =
                this.zhenduan.rechargeLink + this.$route.query.card;
            }
          } else {
            if (this.zhenduan.isGreen == 0) {
              window.location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                "/wap/index.html/#/home?card=" +
                this.$route.query.card;
            } else {
              window.location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                "/wap/index.html/#/recharges?card=" +
                this.$route.query.card;
            }
          }
        } else if (val == 2) {
          if (this.zhenduan.customerServiceLink) {
            window.location.href = this.zhenduan.customerServiceLink;
          } else {
            this.$toast("暂未设置链接");
          }
        } else if (val == 3) {
          if (this.zhenduan.tutorialLink) {
            window.location.href = this.zhenduan.tutorialLink;
          } else {
            this.$toast("暂未设置链接");
          }
        }
      },
      //复制
      copy(val) {
        let input = document.createElement("input");
        input.value = val;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.$toast("复制成功");
      },
      //一卡一码
      autoTestCard() {
        getInfo(this.$route.query.card).then((res) => {
          if (res.status) {
            if (res.data) {
              if (res.data.jump == true) {
                if (this.$route.query.biaoshi) {
                  this.zhenduan = res.data;
                  this.show = true;
                } else {
                  res.data.landingPageUrl =
                    res.data.landingPageUrl +
                    "/wap/index.html#/cardform?card=" +
                    this.$route.query.card +
                    "&biaoshi=1";
                  window.location.href = res.data.landingPageUrl;
                  this.zhenduan = res.data;
                  this.show = true;
                }
              } else {
                this.zhenduan = res.data;
                this.show = true;
              }
            }
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: res.msg,
              })
              .then(() => {
                // on close
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .titleas1111 {
    margin: 10px;
    text-align: left;

    p {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .box {
    background-color: #fff;
    border-radius: 10px;
    background-color: #fff;
  }
  .top {
    padding: 15px 0;
    padding-top: 0;
    border-bottom: 1px solid #c4c4c4;
  }
</style>
